document.addEventListener('DOMContentLoaded', function() {
    var typingEl = document.querySelector('#b5-typing_words');
    var materialsWrap = document.querySelector('.b5-materials-selectors-wrap');
    var compareList = document.querySelector('.b5-compare-products-lists');
    var galleryEl = document.getElementById('b5-featured-share--lightGallery');
    var pressReviewsList = $('.press-reviews__list');

    if (typingEl) {
        var typing_words = typingEl.dataset.words.split(',');
        if (typing_words.length > 1) {
            typingEl.innerHTML = '';
            for (var i = 0; i < typing_words.length; i++) {
                typing_words[i] += ' ^2000';
            }
            new Typed('#b5-typing_words', {
                strings: typing_words,
                typeSpeed: 40,
                backSpeed: 0,
                loop: true,
                showCursor: false,
                smartBackspace: false
            });
        }
    }

    if (compareList && $.fn.slick && Boulies.setting.screenSize == 'large') {
        $('.b5-compare-products-lists').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<div class="slick-prev"></div>',
            nextArrow: '<div class="slick-next"></div>',
            infinite: false,
            speed: 500,
            responsive: [{
                breakpoint: 1280,
                settings: "unslick"
            }]
        });
    }

    if (galleryEl) {
        lightGallery(galleryEl, {
            licenseKey: 'DA7E83CA-6E474542-97592C9F-8A8DFF9D',
            download: false,
            plugins: [lgZoom],
        });
    }

    if (materialsWrap) {
        materialsWrap.addEventListener('mouseover', function(e) {
            var _target = e.target.closest('.b5-material-button');
            if (!_target) return;
            document.querySelectorAll('.b5-material-button').forEach(function(v) {
                v.dataset.status = '';
            });
            _target.dataset.status = 'is_actived';
            document.querySelectorAll('.b5-intro-description--material').forEach(function(v) {
                if (v.dataset.tab == _target.dataset.tab) {
                    v.dataset.status = 'is_actived';
                } else {
                    v.dataset.status = '';
                }
            });
            document.querySelectorAll('.b5-material-image').forEach(function(v) {
                if (v.dataset.tab == _target.dataset.tab) {
                    v.dataset.status = 'is_actived';
                } else {
                    v.dataset.status = '';
                }
            });
        });
    }

    if (compareList) {
        compareList.addEventListener('click', function(e) {
            var _target = e.target.closest('.b5-view-variants-btn');
            if (!_target) return;
            document.querySelectorAll('.b5-view-variants-btn').forEach(function(v) {
                v.dataset.status = '';
            });
            _target.dataset.status = 'is_actived';
            document.querySelectorAll('.b5-collection-product').forEach(function(v) {
                if (v.dataset.series !== _target.dataset.series) {
                    v.style.display = 'none';
                } else {
                    v.style.display = 'block';
                }
            });
        });
    }

    if ($.fn.slick && pressReviewsList.length) {
        pressReviewsList.slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: false,
            responsive: [{
                breakpoint: 650,
                settings: {
                    dots: true,
                    slidesToShow: 1
                }
            }]
        });
    }
});
